import { render, staticRenderFns } from "./AdminUser.vue?vue&type=template&id=0c67341a&"
import script from "./AdminUser.ts?vue&type=script&lang=ts&"
export * from "./AdminUser.ts?vue&type=script&lang=ts&"
import style0 from "./AdminUser.vue?vue&type=style&index=0&id=0c67341a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports